import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'inicio',
    component: () => import('../views/Inicio.vue')
  },
  {
    path: '/nuestro-equipo',
    name: 'nuestroEquipo',
    component: () => import('../views/NuestroEquipo.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Si el usuario vuelve atrás/adelante, que vuelva donde estaba
    if (savedPosition) {
      return savedPosition
    }

    // Si hay hash (ej: #beneficios), que haga scroll suave a esa sección
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }

    // Si no, que vaya arriba del todo
    return { top: 0 }
  }
})

export default router
